export { IssuePage as default } from '@/components/enpages/Ir/Manage/Issue'
